(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["veyra-feature-showcase"] && !Shopify.designMode) return;
  try {
    
  const initializeVeyraFeatureVideos = (root) => {
    root.querySelectorAll('[data-veyra-video-play]').forEach((button) => {
      if (button.dataset.veyraVideoReady === 'true') return;

      const video = button.parentElement.querySelector('video');
      if (!video) return;

      button.dataset.veyraVideoReady = 'true';
      button.addEventListener('click', () => {
        video.play().catch(() => {
          button.hidden = false;
        });
      });
      video.addEventListener('play', () => {
        button.hidden = true;
      });
      video.addEventListener('pause', () => {
        button.hidden = false;
      });
      video.addEventListener('ended', () => {
        button.hidden = false;
      });
    });
  };

  initializeVeyraFeatureVideos(document);
  document.addEventListener('shopify:section:load', (event) => {
    initializeVeyraFeatureVideos(event.target);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["veyra-hero"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('change', (event) => {
    const input = event.target.closest('[data-veyra-product-form] input[type="radio"]');
    if (!input) return;
    const form = input.closest('[data-veyra-product-form]');
    form.querySelector('[data-veyra-variant-id]').value = input.value;
    form.querySelector('[data-veyra-price]').textContent = input.dataset.price;
    form.querySelector('[data-veyra-hero-charger]')?.classList.toggle('is-hidden', input.dataset.duo !== 'true');
    const buttons = form.querySelectorAll('button[type="submit"]');
    const available = input.dataset.available === 'true';
    buttons.forEach((button) => { button.disabled = !available; });
    const addButton = form.querySelector('button[type="submit"]:not([data-veyra-buy-now])');
    addButton.querySelector('span').textContent = available ? addButton.dataset.addLabel : addButton.dataset.soldLabel;
  });

  document.addEventListener('submit', async (event) => {
    const form = event.target.closest('[data-veyra-product-form]');
    if (!form) return;
    event.preventDefault();
    const button = event.submitter || form.querySelector('button[type="submit"]');
    const buttons = form.querySelectorAll('button[type="submit"]');
    const buyNow = button.hasAttribute('data-veyra-buy-now');
    const status = form.querySelector('[data-veyra-form-status]');
    button.classList.add('is-loading');
    buttons.forEach((item) => { item.disabled = true; });
    status.textContent = '';
    const selected = form.querySelector('input[type="radio"]:checked');
    const variantId = Number(selected.value);
    const chargerVariantId = Number(form.dataset.chargerVariantId);
    const duoVariantId = Number(form.dataset.duoVariantId);
    const items = [{ id: variantId, quantity: 1 }];
    if (chargerVariantId && variantId === duoVariantId) {
      items.push({ id: chargerVariantId, quantity: 1, properties: { _veyra_bonus: 'Duo Eyes charger' } });
    }
    try {
      const response = await fetch(window.routes.cart_add_url, {
        method: 'POST',
        headers: { Accept: 'application/json', 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ items, sections: ['cart-drawer', 'cart-icon-bubble'], sections_url: window.location.pathname })
      });
      const result = await response.json();
      if (!response.ok || result.status) throw new Error(result.description || result.message || form.dataset.error);
      if (buyNow) {
        window.location.assign('/checkout');
        return;
      }
      const drawer = document.querySelector('cart-drawer');
      if (drawer) drawer.renderContents(result);
      else window.location.assign(window.routes.cart_url);
      status.textContent = form.dataset.success;
    } catch (error) {
      status.textContent = error.message || form.dataset.error;
    } finally {
      button.classList.remove('is-loading');
      const available = selected?.dataset.available === 'true';
      buttons.forEach((item) => { item.disabled = !available; });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["veyra-media-carousel"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-veyra-media-carousel]').forEach((carousel) => {
    if (carousel.dataset.ready === 'true') return;
    carousel.dataset.ready = 'true';
    const track = carousel.querySelector('[data-veyra-media-track]');
    const move = (direction) => track.scrollBy({ left: direction * track.clientWidth * .82, behavior: 'smooth' });
    carousel.querySelector('[data-veyra-media-previous]')?.addEventListener('click', () => move(-1));
    carousel.querySelector('[data-veyra-media-next]')?.addEventListener('click', () => move(1));
    track.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowLeft') { event.preventDefault(); move(-1); }
      if (event.key === 'ArrowRight') { event.preventDefault(); move(1); }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["veyra-reviews"] && !Shopify.designMode) return;
  try {
    
  const setupVeyraReviews = (root) => {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const reviews = JSON.parse(root.querySelector('[data-review-data]').textContent);
    const grid = root.querySelector('[data-grid]');
    const loadMore = root.querySelector('[data-load-more]');
    const modal = root.querySelector('[data-modal]');
    const modalContent = root.querySelector('[data-modal-content]');
    const previous = root.querySelector('[data-previous]');
    const next = root.querySelector('[data-next]');
    const initial = Number(root.dataset.initial) || 6;
    const increment = Number(root.dataset.load) || 6;
    let filter = 'all';
    let visible = initial;
    let returnFocus;
    let scrollFrame;

    const matches = (review) => filter === 'all' || review.mediaType === filter || review.rating === Number(filter);
    const filtered = () => reviews.filter(matches);

    const showMedia = (review) => {
      modalContent.replaceChildren();
      if (review.mediaType === 'video') {
        if (review.mediaUrl) {
          const media = document.createElement('video');
          media.src = review.mediaUrl;
          media.poster = review.posterUrl || '';
          media.controls = true;
          media.autoplay = true;
          media.playsInline = true;
          modalContent.append(media);
        }
      } else {
        const media = document.createElement('img');
        media.src = review.mediaUrl;
        media.alt = review.mediaAlt;
        modalContent.append(media);
      }
      modal.showModal();
    };

    const card = (review) => {
      const article = document.createElement('article');
      article.className = 'veyra-review';
      if (review.mediaType !== 'none' && (review.posterUrl || review.mediaUrl)) {
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'veyra-review__media';
        button.setAttribute('aria-label', root.dataset.openMedia + ': ' + review.author);
        const image = document.createElement('img');
        image.src = review.posterUrl || review.mediaUrl;
        image.alt = review.mediaAlt;
        image.loading = 'lazy';
        image.decoding = 'async';
        button.append(image);
        if (review.mediaType === 'video') {
          const play = document.createElement('span');
          play.className = 'veyra-review__play';
          play.textContent = '▶';
          play.setAttribute('aria-hidden', 'true');
          button.append(play);
        }
        button.addEventListener('click', () => {
          returnFocus = button;
          showMedia(review);
        });
        article.append(button);
      }
      const body = document.createElement('div');
      body.className = 'veyra-review__body';
      const stars = document.createElement('span');
      stars.className = 'veyra-review__stars';
      stars.textContent = '★★★★★'.slice(0, review.rating);
      stars.setAttribute('aria-label', review.rating + ' out of 5 stars');
      const copy = document.createElement('p');
      copy.textContent = review.body;
      const meta = document.createElement('div');
      meta.className = 'veyra-review__meta';
      const author = document.createElement('div');
      const name = document.createElement('strong');
      name.textContent = review.author;
      author.append(name);
      if (review.verified) {
        const verified = document.createElement('span');
        verified.className = 'veyra-review__verified';
        verified.textContent = '✓ ' + root.dataset.verified;
        author.append(verified);
      }
      const date = document.createElement('time');
      date.dateTime = review.date;
      date.textContent = review.displayDate;
      meta.append(author, date);
      body.append(stars, copy, meta);
      article.append(body);
      return article;
    };

    const updateNavigation = () => {
      previous.disabled = grid.scrollLeft <= 4;
      next.disabled = grid.scrollLeft + grid.clientWidth >= grid.scrollWidth - 4;
    };

    const scrollCarousel = (direction) => {
      const item = grid.querySelector('.veyra-review');
      if (!item) return;
      const gap = Number.parseFloat(getComputedStyle(grid).columnGap) || 16;
      grid.scrollBy({ left: direction * (item.getBoundingClientRect().width + gap), behavior: 'smooth' });
    };

    const render = () => {
      const items = filtered();
      grid.replaceChildren(...items.slice(0, visible).map(card));
      grid.scrollLeft = 0;
      loadMore.hidden = visible >= items.length;
      requestAnimationFrame(updateNavigation);
    };

    root.querySelectorAll('[data-filter]').forEach((button) => {
      button.addEventListener('click', () => {
        root.querySelectorAll('[data-filter]').forEach((item) => item.classList.remove('is-active'));
        button.classList.add('is-active');
        filter = button.dataset.filter;
        visible = initial;
        render();
      });
    });
    loadMore.addEventListener('click', () => {
      visible += increment;
      render();
    });
    previous.addEventListener('click', () => scrollCarousel(-1));
    next.addEventListener('click', () => scrollCarousel(1));
    grid.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
        event.preventDefault();
        scrollCarousel(event.key === 'ArrowLeft' ? -1 : 1);
      }
    });
    grid.addEventListener('scroll', () => {
      cancelAnimationFrame(scrollFrame);
      scrollFrame = requestAnimationFrame(updateNavigation);
    }, { passive: true });
    window.addEventListener('resize', updateNavigation, { passive: true });
    root.querySelector('[data-close]').addEventListener('click', () => modal.close());
    modal.addEventListener('click', (event) => {
      if (event.target === modal) modal.close();
    });
    modal.addEventListener('close', () => {
      modalContent.replaceChildren();
      returnFocus?.focus();
    });
    render();
  };

  document.querySelectorAll('[data-veyra-reviews]').forEach(setupVeyraReviews);
  document.addEventListener('shopify:section:load', (event) => {
    const root = event.target.querySelector('[data-veyra-reviews]');
    if (root) setupVeyraReviews(root);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["veyra-sticky-atc"] && !Shopify.designMode) return;
  try {
    
  const sticky = document.querySelector('[data-veyra-sticky]');
  if (sticky) {
    sticky.querySelector('[data-veyra-sticky-button]').addEventListener('click', () => {
      const button = document.querySelector('[id^="ProductSubmitButton-"]:not([disabled])');
      if (button) button.click();
      else document.querySelector('#shop')?.scrollIntoView({ behavior: 'smooth' });
    });
    document.addEventListener('change', (event) => {
      if (!event.target.matches('input[type="radio"][name^="Type"], select[name^="options"]')) return;
      window.setTimeout(() => {
        const price = document.querySelector('[id^="price-"] .price-item--regular, [id^="price-"] .price-item--sale');
        if (price) sticky.querySelector('[data-veyra-sticky-price]').textContent = price.textContent.trim();
        const button = document.querySelector('[id^="ProductSubmitButton-"]');
        const stickyButton = sticky.querySelector('[data-veyra-sticky-button]');
        stickyButton.disabled = !button || button.disabled;
        if (button?.textContent.trim()) stickyButton.textContent = button.textContent.trim();
      }, 250);
    });
  }

  } catch(e) { console.error(e); }
})();
})();
